var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcptSucc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3 3.303a.8.8 0 00-.8.8v9.4a.8.8 0 00.8.8h11.4a.8.8 0 00.8-.8v-9.4a.8.8 0 00-.8-.8H1.3zm.767 2.465l4.157 2.771a1.4 1.4 0 001.553 0l4.156-2.771-.665-.998L7.11 7.54a.2.2 0 01-.222 0L2.733 4.77l-.666.998z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10.592a4.375 4.375 0 118.75 0 4.375 4.375 0 01-8.75 0z",
    fill: "#5FC375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.37l1.896 1.896 3.104-3.104",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/rcpt-succ.1d4aaa98.svg";
export { SvgRcptSucc as ReactComponent };